export default "__VITE_ASSET__DVs8oAPB__"